import axiosClient from "utils/api";
const URI = "/admin/user";

export const getUsers = async (payload) => {
  const URL = `${URI}/getUsers`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Country:", error);
    throw error;
  }
};

export const changeUserPassword = async (payload) => {
  const { id, ...rest } = payload;

  const URL = `${URI}/${id}/password`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred change user password:", error);
    throw error;
  }
};

export const deleteUsers = async (payload) => {
  const { id, ...rest } = payload;

  const URL = `${URI}/delete/${id}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    console.log("response of delete", response);
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Users:", error);
    throw error;
  }
};

export const blockUsers = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/block/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Block Users:", error);
    throw error;
  }
};

export const unblockUsers = async (payload) => {
  const URL = `${URI}/unblock/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Unblock Users:", error);
    throw error;
  }
};

export const restoreUsers = async (payload) => {
  const URL = `${URI}/restore/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Restore Users:", error);
    throw error;
  }
};

export const getUserDetail = async (payload) => {
  const URL = `${URI}/details/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user detail:", error);
    throw error;
  }
};

export const getUserFolders = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/folder/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user folder:", error);
    throw error;
  }
};

export const getUserLabels = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/label/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user labels:", error);
    throw error;
  }
};

export const getUserFilters = async (payload) => {
  const URL = `${URI}/getFiveEmailFilters/${payload?.id}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user filter:", error);
    throw error;
  }
};

export const getUserAllFilters = async (payload) => {
  const URL = `${URI}/getEmailFilterList`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get all filter:", error);
    throw error;
  }
};

export const getUserSessions = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/session/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get Sessions:", error);
    throw error;
  }
};

export const deleteUserSessions = async (payload) => {
  const URL = `${URI}/session/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Delete User Sessions:", error);
    throw error;
  }
};

export const inactiveUserSessions = async (payload) => {
  const URL = `${URI}/session/${payload?.id}`;

  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred inactive User:", error);
    throw error;
  }
};

export const getUserTodayLogs = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/todayLogs/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get today logs:", error);
    throw error;
  }
};

export const downloadUserAllLogs = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/logs/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during download all logs:", error);
    throw error;
  }
};

export const getChatReportUserList = async (payload) => {
  const URL = `${URI}/getChatReportList`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get chat report user list:", error);
    throw error;
  }
};